'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Typography } from '@/components/ui/typography/typography.component';

interface CartItemWarningProps {
  children: string;
}

export function CartItemWarning({ children }: CartItemWarningProps) {
  return (
    <Typography
      className="flex w-full items-center justify-center rounded-sm border border-warning-300 bg-warning-100 px-2 py-1 text-base font-semibold leading-6 text-warning-800"
      data-testid={DataTestIdEnum.CART_ITEM_WARNING}
    >
      {children}
    </Typography>
  );
}
